import { Breakpoint, Color, FontWeight, SimpleMarkdown } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${Breakpoint.SmallDesktop} {
    min-width: 908px;
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CloseButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px;
`;

export const CloseButton = styled.button.attrs({ type: 'button' })``;

export const TileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0 16px 40px;
  
  @media ${Breakpoint.SmallDesktop} {
    padding: 20px 40px 40px 40px;
  }
`;

export const Header = styled(SimpleMarkdown)`
  strong {
    color: ${Color.Gray500};
    font-weight: ${FontWeight.Regular};
  }
`;
